import React from "react";
import { useParams } from "react-router";
import { useRoutes } from "../../hooks/useRoutes";
import { LegalNote } from "./LegalNote";

export const LegalNotePage = () => {
  const { pushImportConnection } = useRoutes();
  const { bankSlug } = useParams<"bankSlug">();

  const handleClick = () => {
    pushImportConnection(bankSlug!, "FIN_API");
  };

  return <LegalNote onSubmit={handleClick} />;
};
